module.exports = __webpack_public_path__ + "media/application/images/2018/email@2x-428669cec5247ce3ed6b3a73e44b363e.png";